import Model  from '@/utils/v01/ActiveModel';

export default class Tps extends Model { 
    static backend = '/survey/tps/';   

    static entity = 'tps';    
    
    static fields () {
        return {
            id: this.attr(null),
            idpro: this.attr(null),
            idkab: this.attr(null),
            idkec: this.attr(null),
            idkel: this.attr(null),
            no: this.attr(null),
            name: this.attr(''),
            alamat: this.attr(null),
            pt_l: this.attr(null),
            pt_p: this.attr(null),
            geom: this.attr(null),
            status: this.attr(null),
            created_at: this.attr(null),
            created_by: this.attr(null),
            updated_at: this.attr(null),
            updated_by: this.attr(null),
        }
    }
    
    static nodes(params={}){
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }
}

